/**
 * The house mark: a rack, drawn as one path per beam.
 *
 * Inline SVG rather than an image file, for the same reason nothing else here
 * is a file — `img-src 'self' data:` with no sprite sheet, and it inherits
 * `currentColor` so it is correct in any palette without a second asset.
 */

export function Antlers({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 240 96"
      fill="none"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      role="img"
      aria-label="A whitetail rack"
    >
      <g color="#c9a227">
        {/* left beam and its tines */}
        <path d="M118 92 C 104 74, 86 66, 62 58 C 44 52, 30 40, 22 22" />
        <path d="M96 68 C 92 56, 92 44, 96 32" />
        <path d="M74 60 C 68 48, 66 36, 68 24" />
        <path d="M50 50 C 44 40, 42 30, 44 20" />
        <path d="M30 34 C 24 26, 22 18, 24 10" />
        {/* right beam, mirrored */}
        <path d="M122 92 C 136 74, 154 66, 178 58 C 196 52, 210 40, 218 22" />
        <path d="M144 68 C 148 56, 148 44, 144 32" />
        <path d="M166 60 C 172 48, 174 36, 172 24" />
        <path d="M190 50 C 196 40, 198 30, 196 20" />
        <path d="M210 34 C 216 26, 218 18, 216 10" />
        {/* skull plate */}
        <path d="M112 94 L 120 84 L 128 94" />
      </g>
    </svg>
  );
}
